import { BehaviorSubject } from 'rxjs';
import { IFontStyleModel } from '../../tn.common';

export class StyleSelection {
    selection$ = new BehaviorSubject<IFontStyleModel[]>([]);
    selectedStyles: IFontStyleModel[] = [];

    toggle(styles: IFontStyleModel[]): void{
        // someone passed selectedStyles in.
        // empty it out and be done with it
        if (styles === this.selectedStyles) {
            return this.selectNone();
        }
        styles.forEach((style) => {
            const index = this.selectedStyles.indexOf(style);
            if (index === -1) {
                this.selectedStyles.push(style);
            } else {
                this.selectedStyles.splice(index, 1);
            }
        });
        this.selection$.next(this.selectedStyles);
    }

    get(): IFontStyleModel[] {
        return this.selectedStyles;
    }

    selectAll(styles: IFontStyleModel[]): void {
        // someone passed selectedStyles in.
        // we're good. no-op.
        if (styles === this.selectedStyles) {
            return;
        }


        // preserve references.
        this.selectedStyles.splice(0, this.selectedStyles.length);
        styles.forEach((style) => {
            this.selectedStyles.push(style);
        });
        this.selection$.next(this.selectedStyles);
    }

    selectNone(): void {
        this.selectedStyles.splice(0, this.selectedStyles.length);
        this.selection$.next(this.selectedStyles);
    }

    toggleGroup(styles: IFontStyleModel[]): void {
        // If all styles are selected deselect them, otherwise select the remaining styles
        const allSelected = styles.every((style) => this.selectedStyles.indexOf(style) > -1);
        if (allSelected) {
            this.toggle(styles);
        } else {
            styles.forEach((style) => {
                const index = this.selectedStyles.indexOf(style);
                if (index === -1) {
                    this.selectedStyles.push(style);
                }
            });
        }
        this.selection$.next(this.selectedStyles);
    }
}
